import { api } from "./axios";

// User related endpoints
export const authApi = {
  signup: (data: {
    fullName: string;
    email: string;
    password: string;
    code: string;
    termsAccepted: boolean;
  }) => api.post("/auth/signup", data),

  login: (data: { email: string; password: string }) =>
    api.post("/auth/login", data),

  validateCode: (code: string) => api.post("/auth/validate-id", { code }),

  forgetPassword: (data: { email: string }) =>
    api.post("/auth/forget-password", data),

  resetPassword: (data: {
    email: string;
    token: string;
    newPassword: string;
  }) => api.post("/auth/reset-password", data),
};
